import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase"; // Your Firebase config
import { ref, get,set } from "firebase/database";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Correct answer icon
import CancelIcon from "@mui/icons-material/Cancel"; // Incorrect answer icon
import AssignmentIcon from "@mui/icons-material/Assignment"; // Test icon
import PersonIcon from "@mui/icons-material/Person"; // Student icon
import SchoolIcon from "@mui/icons-material/School"; // Class icon
import DoneAllIcon from "@mui/icons-material/DoneAll"; // Submit icon
import VisibilityIcon from "@mui/icons-material/Visibility"; // View answers icon
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"; // Hide answers icon

const StudentTestPage = () => {
  const { udiseNo, class: className, division, subject, testName } = useParams();
  console.log("useParams",useParams());
  
  const [questions, setQuestions] = useState([]);
  const [userAnswers, setUserAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [studentInfo, setStudentInfo] = useState({
    studentName: "",
    rollNo: "",
    serialNo: "", 
  });
  const [testStarted, setTestStarted] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [viewAnswers, setViewAnswers] = useState(false);
   const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');


   
     useEffect(() => {
       const storedLanguage = localStorage.getItem('language') || 'English';
       setLanguage(storedLanguage);
     }, []);


useEffect(() => {
  const fetchTestDetails = async () => {
    const path = `schoolRegister/${udiseNo}/Exam/${className}&&${division}&&${subject}/tests`;
  
    try {
      const testRef = ref(db, path);
      const snapshot = await get(testRef);
  
      if (snapshot.exists()) {
        const data = snapshot.val();
        console.log("Data found at path:", path);
        console.log("Data:", data);
        const testNameTrimmed = testName.trim();
        console.log("testName",testNameTrimmed);
        
        if (data && data[testNameTrimmed]) {
          const testData = data[testNameTrimmed];
          console.log("Test data found:", testData);
  
          if (testData && testData.questions) {
            const questionsArray = Object.values(testData.questions);
            const showScore = testData.showScore || false;
  
            setQuestions(questionsArray);
            setShowScore(showScore);
          } else {
            console.error("Questions not found in the fetched data:", testData);
            alert("No questions found for the provided test.");
            setQuestions([]);
          }
        } else {
          console.error("Test data not found at path:", path);
          alert("No test data found for the provided details.");
          setQuestions([]);
        }
      } else {
        console.error("No data found at path:", path);
        alert("No data found for the provided details.");
        setQuestions([]);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      alert("Failed to fetch questions.");
    }
  };
  fetchTestDetails();
}, [className, division, subject, testName, udiseNo]);
  const handleOptionChange = (questionIndex, option) => {
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionIndex]: option, // Update the answer for the specific question index
    }));
  };
  const handleRollNoChange = async (e) => {
    const rollNo = e.target.value;
    setStudentInfo((prev) => ({ ...prev, rollNo }));
  
    if (rollNo) {
      // Fetch student data based on roll number
      const studentData = await fetchStudentData(rollNo);
      if (studentData) {
        setStudentInfo((prev) => ({
          ...prev,
          studentName: studentData.stdName + " " + studentData.stdFather + " " + studentData.stdSurname,
          serialNo: studentData.serialNo,
        }));
      } else {
        setStudentInfo((prev) => ({
          ...prev,
          studentName: "",
          serialNo: "",
        }));
        alert("No student found with the provided roll number.");
      }
    } else {
      setStudentInfo((prev) => ({ ...prev, studentName: "", serialNo: "" }));
    }
  };

  const fetchStudentData = async (rollNo) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNo}/studentData.json`
      );
      const data = await response.json();
  
  
      // Check if data is an array and filter out null values
      if (!Array.isArray(data)) {
        console.error("Fetched data is not an array:", data);
        return null; // Return null if data is not an array
      }
  
      // Find the student with the matching roll number, currentClass, and division
      const student = Object.values(data)
      .filter((student)=>student!==null)
      .find(
        (student) =>
          student.rollNo == rollNo &&
          student.currentClass == className &&
          student.division == division
      );
  
      if (student) {
        return student; // Return the student data
      } else {
        return null; // Return null if not found
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
      return null;
    }
  };
  const handleSubmitTest = async () => {
    let marks = 0;

    const questionsData = {};
    questions.forEach((question, index) => {
      const userAnswer = userAnswers[index] || null;
      if (userAnswer === question.correctAnswer) {
        marks += parseInt(question.marks);
      }

      questionsData[`Q ${index + 1}`] = {
        questionText: question.question,
        correctAnswer: question.correctAnswer,
        userAnswer: userAnswer,
      };
    });

    const studentKey = `${studentInfo.serialNo}&&${studentInfo.studentName}&&${studentInfo.rollNo}&&${className}&&${division}&&${subject}`;
    const studentResultPath = `schoolRegister/${udiseNo}/Exam/studentResult/${studentKey}/${testName}`;

    const studentData = {
      questions: questionsData,
      score: marks,
    };

    try {
      await set(ref(db, studentResultPath), studentData);
      // alert(`Test Submitted! You scored ${marks} out of ${questions.length}`);
      alert(`Test Submitted!`);
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error saving test data:", error);
      alert("Failed to submit test data.");
    }
  };

  const handleStartTest = () => {
    if (!studentInfo.studentName || !studentInfo.rollNo) {
      alert("Please fill out all the fields before starting the test.");
      return;
    }
    setTestStarted(true);
  };

  if (!testStarted) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          padding: "20px",
          backgroundColor: "#f4f6f9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: "500px",
            width: "100%",
            padding: "20px",
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <AssignmentIcon
            style={{ fontSize: "48px", color: "#4CAF50", marginBottom: "16px" }}
          />
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "600",
              marginBottom: "20px",
            }}
          >
            {language === "English" ? "Student Test Information" : "विद्यार्थी चाचणी माहिती"}
          </h1>
          <form
            onSubmit={(e) => e.preventDefault()}
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >

             <div>
              <label
                htmlFor="rollNo"
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "8px",
                  display: "block",
                }}
              >
                <SchoolIcon
                  style={{ marginRight: "8px", verticalAlign: "middle" }}
                />
                  {language === "English" ? "Roll No" : "हजेरी नंबर"}
              </label>
              <input
                id="rollNo"
                type="text"
                placeholder="Enter your roll number"
                value={studentInfo.rollNo}
                onChange={handleRollNoChange} // Use the new function
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  width: "95%",
                }}
                required
              />
            </div>
            <div>
              <label
                htmlFor="studentName"
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "8px",
                  display: "block",
                }}
              >
                <PersonIcon
                  style={{ marginRight: "8px", verticalAlign: "middle" }}
                />
                {language === "English" ? " Student Name" : "विद्यार्थ्याचे नाव"}
              </label>
              <input
                id="studentName"
                type="text"
                placeholder="Enter your name"
                value={studentInfo.studentName}
                onChange={(e) =>
                  setStudentInfo({
                    ...studentInfo,
                    studentName: e.target.value,
                  })
                }
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  width: "95%",
                }}
                required
              />
            </div>
         
            <button
              onClick={handleStartTest}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "12px 20px",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s",
                marginTop: "16px",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
            >
              {language === "English" ? " Start Test" : "चाचणी सुरू करा"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (questions.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "20px",
          color: "#555",
        }}
      >
      {language === "English" ? "Loading test..." : "चाचणी लोड होत आहे..."}
      </div>
    );
  }

  return (
    <div className="main-content-of-page">
      <div style={{ width: "96%", padding: "30px", height: "90vh" }}>
        <h3
          style={{
            textAlign: "center",
            backgroundColor: "gray",
            color: "white",
            padding: "5px",
            borderRadius: "8px",
            marginBottom: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <AssignmentIcon style={{ fontSize: "22px" }} />
           {language === "English" ? "Student Test" : "विद्यार्थी चाचणी"}
        </h3>
        {!isSubmitted && (
          <div
            style={{
              marginBottom: "20px",
              padding: "20px",
              backgroundColor: "#f1f1f1",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <p>
              <PersonIcon
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              />
              <strong>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</strong> {studentInfo.studentName}
            </p>
            <p>
              <SchoolIcon
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              />
              <strong>{language === "English" ? "Roll No" : "हजेरी नंबर"}</strong> {studentInfo.rollNo}
            </p>
            <p>
              <AssignmentIcon
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              />
              <strong>{language === "English" ? "Subject" : "विषय"}</strong> {subject}
            </p>
            <p>
              <SchoolIcon
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              />
              <strong>{language === "English" ? "Class" : "वर्ग"}</strong> {className}-{division}
            </p>
          </div>
        )}

        {!isSubmitted ? (
          <ol style={{ listStyleType: "none", padding: 0 }}>
            {questions.map((question, index) => (
              <li
                key={index}
                style={{
                  marginBottom: "20px",
                  padding: "20px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <p style={{ fontWeight: "bold", marginBottom: "16px" }}>
                  {index + 1}. {question.question}
                </p>
                {question.options.map((option, optIndex) => (
                  <div key={optIndex} style={{ marginBottom: "8px" }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <input style={{width:'auto'}}
                        type="radio"
                        name={`question-${index}`}
                        value={option}
                        onChange={() => handleOptionChange(index, option)}
                      />
                      {option}
                    </label>
                  </div>
                ))}
              </li>
            ))}
          </ol>
        ) : (
          <div>
            <h2
              style={{
                textAlign: "center",
                color: "green",
                marginBottom: "20px",
              }}
            >
              <DoneAllIcon
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              /> 
            {language === "English" ? "Thank you for submitting the test!" : "चाचणी सबमिट केल्याबद्दल धन्यवाद!"}
            </h2> 
            {showScore === "Yes" && (
              <button
                onClick={() => setViewAnswers(!viewAnswers)}
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {viewAnswers ? <VisibilityOffIcon /> : <VisibilityIcon />}
                {viewAnswers ? "Hide Answers" : "View Answers"}
              </button>
            )}

            {viewAnswers && (
              <ol style={{ listStyleType: "none", padding: 0 }}>
                {questions.map((question, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "20px",
                      padding: "20px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <p style={{ fontWeight: "bold", marginBottom: "16px" }}>
                      {index + 1}{`)`} &nbsp; {question.question}
                    </p>
                    {question.options.map((option, optIndex) => (
                      <div key={optIndex} style={{ marginBottom: "8px", width:'auto', textAlign:'left', left:'0', position:'relative' }}>
                    
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px",
                            borderRadius: "4px", 
                            backgroundColor:
                              userAnswers[index] === option
                                ? option === question.correctAnswer
                                  ? "#4CAF50"
                                  : "#f44336"
                                : option === question.correctAnswer
                                ? "#e8f5e9"
                                : "#f5f5f5",
                            color:
                              userAnswers[index] === option
                                ? "white"
                                : option === question.correctAnswer
                                ? "#2e7d32"
                                : "#333",
                          }}
                        >  <input
                            type="radio"
                            name={`question-${index}`}
                            value={option}
                            checked={userAnswers[index] === option}
                            disabled style={{width:'auto'}}
                          />
                       
                          {option}
                          {userAnswers[index] === option &&
                            (option === question.correctAnswer ? (
                              <CheckCircleIcon style={{ color: "white" }} />
                            ) : (
                              <CancelIcon style={{ color: "white" }} />
                            ))}
                        </label>
                      </div>
                    ))}
                  </li>
                ))}
              </ol>
            )}
          </div>
        )}

        {!isSubmitted && (
          <button
            onClick={handleSubmitTest}
            style={{
              backgroundColor: "#f44336",
              color: "white",
              padding: "8px 10px",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer",
              margin: "5px auto 50px auto",
            }}
          >
            <DoneAllIcon />
             {language === "English" ? " Submit Test" : "चाचणी सबमिट करा"}
          </button>
        )}
      </div>
    </div>
  );
};

export default StudentTestPage;